module.exports = __webpack_public_path__ + "static/img/A180.8350a00d.jpg";